import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/terms-of-service/page.tsx");
